(function () {
  'use strict';

  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var number = new Intl.NumberFormat('en-US');

  var products = {
    postcards: {
      label: 'print-only postcards',
      note: 'Full-color print-only postcard packages. Mailing services are available separately.',
      handle: 'custom-postcards',
      tiers: [
        [1000, 61.99, '44487245037671'], [2500, 139.99, '44487245070439'],
        [5000, 204, '44487245103207'], [10000, 374, '44487245135975']
      ]
    },
    eddm: {
      label: 'EDDM printing and mailing',
      note: 'Current EDDM package pricing. Route selection, eligibility, postage, and drop details are confirmed during order review.',
      handle: 'eddm-printing-mailing',
      tiers: [
        [1000, 710, '44487245332583'], [2500, 1700, '44487245365351'],
        [5000, 3150, '44487245398119'], [10000, 6100, '44487245430887']
      ]
    },
    targeted: {
      label: 'targeted postcard mailing',
      note: 'Current targeted-mail package pricing. Audience, list, postal, and privacy details are confirmed during order review.',
      handle: 'targeted-postcard-mailing',
      tiers: [
        [1000, 990, '44487245529191'], [2500, 1975, '44487245561959'],
        [5000, 3900, '44487245594727'], [10000, 7500, '44487245627495']
      ]
    },
    'door-hangers': {
      label: 'door hangers',
      note: 'Current door-hanger package pricing. Choose the artwork path on the product page.',
      handle: 'door-hangers',
      tiers: [
        [100, 89, '41073821909095'], [250, 159, '41073821941863'],
        [500, 269, '41073821974631'], [1000, 334, '41073822007399']
      ]
    },
    'yard-signs': {
      label: '24 × 18 yard signs with stakes',
      note: 'Current 24 × 18 yard-sign packages with stakes included.',
      handle: 'custom-yard-signs',
      tiers: [
        [10, 119, '44487245725799'], [20, 189, '44487245758567'],
        [50, 275, '44487245791335'], [100, 449, '44487245824103'],
        [250, 1109, '44487245856871'], [500, 2199, '44487245889639']
      ]
    },
    stickers: {
      label: '2 × 1 custom stickers',
      note: 'Baseline pricing for 2 × 1 stickers. Many more sizes are available on the product page.',
      handle: 'stickers',
      tiers: [
        [100, 59, '41074690326631'], [250, 69, '41074690359399'],
        [500, 99, '41074690392167'], [1000, 139, '41074690424935']
      ]
    }
  };

  function findTier(product, requested) {
    for (var i = 0; i < product.tiers.length; i += 1) {
      if (product.tiers[i][0] >= requested) return product.tiers[i];
    }
    return null;
  }

  function productUrl(product, tier) {
    var url = '/products/' + product.handle;
    return tier && tier[2] ? url + '?variant=' + tier[2] : url;
  }

  function setupPriceCalculator(root) {
    var form = root.querySelector('[data-price-form]');
    if (!form) return;
    var type = form.querySelector('[data-product-type]');
    var quantity = form.querySelector('[data-product-quantity]');
    var note = form.querySelector('[data-product-note]');
    var defaults = { postcards: 1000, eddm: 1000, targeted: 1000, 'door-hangers': 500, 'yard-signs': 50, stickers: 250 };

    function render() {
      var product = products[type.value] || products.postcards;
      var requested = Math.max(1, Math.floor(Number(quantity.value) || 1));
      quantity.value = requested;
      note.textContent = product.note;
      var tier = findTier(product, requested);
      var last = product.tiers[product.tiers.length - 1];
      var title = root.querySelector('[data-price-title]');
      var total = root.querySelector('[data-price-total]');
      var tierOut = root.querySelector('[data-price-tier]');
      var unit = root.querySelector('[data-price-unit]');
      var extra = root.querySelector('[data-price-extra]');
      var message = root.querySelector('[data-price-message]');
      var link = root.querySelector('[data-price-link]');
      var secondaryLink = root.querySelector('[data-price-secondary]');

      if (!tier) {
        title.textContent = 'Bulk ' + product.label + ' pricing';
        total.textContent = 'Request a bulk quote';
        tierOut.textContent = 'More than ' + number.format(last[0]);
        unit.textContent = 'Custom';
        extra.textContent = '—';
        message.textContent = 'Large campaigns are quoted individually so production, postage, routes or lists, shipping, and schedule can be priced accurately.';
        link.textContent = 'Request bulk pricing';
        link.href = '/pages/contact';
        if (secondaryLink) secondaryLink.style.display = 'none';
        return;
      }

      title.textContent = number.format(tier[0]) + ' ' + product.label;
      total.textContent = money.format(tier[1]);
      tierOut.textContent = number.format(tier[0]);
      unit.textContent = money.format(tier[1] / tier[0]);
      extra.textContent = number.format(tier[0] - requested) + ' pieces';
      message.textContent = tier[0] === requested
        ? 'This is an exact match to a current online package.'
        : 'This is the smallest current package that covers ' + number.format(requested) + ' pieces.';
      link.textContent = 'Shop this package';
      link.href = productUrl(product, tier);
      if (secondaryLink) secondaryLink.style.removeProperty('display');
    }

    type.addEventListener('change', function () {
      quantity.value = defaults[type.value] || 1;
      render();
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); render(); });
    quantity.addEventListener('input', render);
    render();
  }

  function setupRoutePlanner(root) {
    var rows = root.querySelector('[data-route-rows]');
    if (!rows) return;
    var zip = root.querySelector('[data-route-zip]');
    var includeBusiness = root.querySelector('[data-include-business]');
    var rate = Number(root.getAttribute('data-usps-rate')) || 0.26;
    var storageKey = 'sticprint-eddm-route-plan-v1';
    var eddm = products.eddm;

    function createInput(label, className, typeName) {
      var input = document.createElement('input');
      input.className = className;
      input.setAttribute('aria-label', label);
      if (typeName === 'number') {
        input.type = 'number'; input.min = '0'; input.step = '1'; input.inputMode = 'numeric';
      } else {
        input.type = 'text'; input.maxLength = 24; input.autocomplete = 'off';
      }
      return input;
    }

    function addRow(route, residential, business) {
      var tr = document.createElement('tr');
      var routeCell = document.createElement('td');
      var resCell = document.createElement('td');
      var bizCell = document.createElement('td');
      var actionCell = document.createElement('td');
      var routeInput = createInput('Carrier route ID', 'sp-route-id', 'text');
      var resInput = createInput('Residential addresses', 'sp-route-residential', 'number');
      var bizInput = createInput('Business addresses', 'sp-route-business', 'number');
      var remove = document.createElement('button');
      routeInput.value = route || '';
      resInput.value = residential === undefined ? '' : residential;
      bizInput.value = business === undefined ? '' : business;
      remove.type = 'button'; remove.className = 'sp-route-remove'; remove.setAttribute('aria-label', 'Remove this route'); remove.textContent = 'Remove';
      routeCell.appendChild(routeInput); resCell.appendChild(resInput); bizCell.appendChild(bizInput); actionCell.appendChild(remove);
      tr.appendChild(routeCell); tr.appendChild(resCell); tr.appendChild(bizCell); tr.appendChild(actionCell);
      rows.appendChild(tr);
      tr.addEventListener('input', update);
      remove.addEventListener('click', function () {
        tr.remove(); if (!rows.children.length) addRow('', '', ''); update();
      });
    }

    function planData() {
      var routeData = [];
      rows.querySelectorAll('tr').forEach(function (row) {
        routeData.push({
          route: row.querySelector('.sp-route-id').value.trim(),
          residential: Math.max(0, Math.floor(Number(row.querySelector('.sp-route-residential').value) || 0)),
          business: Math.max(0, Math.floor(Number(row.querySelector('.sp-route-business').value) || 0))
        });
      });
      return { zip: zip.value.trim(), includeBusiness: includeBusiness.checked, routes: routeData };
    }

    function save(data) {
      try { window.localStorage.setItem(storageKey, JSON.stringify(data)); } catch (error) { /* Local storage may be disabled. */ }
    }

    function update() {
      var data = planData();
      var active = data.routes.filter(function (route) { return route.route || route.residential || route.business; });
      var pieces = active.reduce(function (sum, route) { return sum + route.residential + (data.includeBusiness ? route.business : 0); }, 0);
      var tier = findTier(eddm, pieces);
      root.querySelector('[data-route-count]').textContent = number.format(active.length);
      root.querySelector('[data-piece-count]').textContent = number.format(pieces);
      root.querySelector('[data-postage-reference]').textContent = money.format(pieces * rate);
      var tierOut = root.querySelector('[data-eddm-tier]');
      var detail = root.querySelector('[data-eddm-detail]');
      var link = root.querySelector('[data-eddm-link]');
      if (!pieces) {
        tierOut.textContent = 'Add route counts';
        detail.textContent = 'The smallest live package that covers the entered delivery count will appear here.';
        link.textContent = 'View EDDM options'; link.href = productUrl(eddm, null);
      } else if (!tier) {
        tierOut.textContent = 'Custom volume';
        detail.textContent = number.format(pieces) + ' pieces needs bulk campaign pricing so postage, route counts, production, and schedule can be confirmed accurately.';
        link.textContent = 'Request bulk pricing'; link.href = '/pages/contact';
      } else {
        tierOut.textContent = number.format(tier[0]) + ' pieces · ' + money.format(tier[1]);
        detail.textContent = 'Covers ' + number.format(pieces) + ' entered addresses with ' + number.format(tier[0] - pieces) + ' pieces of package capacity remaining.';
        link.textContent = 'Shop the ' + number.format(tier[0]) + ' package'; link.href = productUrl(eddm, tier);
      }
      save(data);
    }

    function restore() {
      var saved = null;
      try { saved = JSON.parse(window.localStorage.getItem(storageKey)); } catch (error) { saved = null; }
      if (saved && Array.isArray(saved.routes) && saved.routes.length) {
        zip.value = saved.zip || '';
        includeBusiness.checked = saved.includeBusiness !== false;
        saved.routes.forEach(function (route) { addRow(route.route, route.residential, route.business); });
      } else addRow('', '', '');
      update();
    }

    root.querySelector('[data-add-route]').addEventListener('click', function () { addRow('', '', ''); update(); });
    root.querySelector('[data-clear-routes]').addEventListener('click', function () {
      rows.textContent = ''; zip.value = ''; includeBusiness.checked = true; addRow('', '', ''); update();
    });
    root.querySelector('[data-load-sample]').addEventListener('click', function () {
      rows.textContent = ''; zip.value = '83702'; includeBusiness.checked = true;
      addRow('EXAMPLE-C001', 410, 18); addRow('EXAMPLE-C002', 535, 22); update();
    });
    includeBusiness.addEventListener('change', update);
    zip.addEventListener('input', update);
    root.querySelectorAll('[data-usps-map]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (zip.value && !/^[0-9]{5}$/.test(zip.value)) {
          event.preventDefault(); zip.setCustomValidity('Enter a five-digit ZIP Code or leave this field blank.'); zip.reportValidity(); zip.focus();
        } else zip.setCustomValidity('');
      });
    });
    restore();
  }

  document.querySelectorAll('[data-sp-tools]').forEach(function (root) {
    setupPriceCalculator(root);
    setupRoutePlanner(root);
  });
})();

